import { FC } from 'react';

const ErrorUserNotFound: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>User Not Found</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        Please try again in a few minutes! <br />
      </div>
    </>
  );
};

export { ErrorUserNotFound };
